import { createAsyncThunk } from '@reduxjs/toolkit';
import { createCreativeCommercial, updateCreativeCommercial } from 'modules/api/content';
import { CancelFunctions, CodeNameModel } from 'components/common/types';
import { ThunkApiConfig } from 'components/common/types/Redux.types';
import { setCommercialId, setCreativeProductCategory } from './reducer';

type SetProductCategoryProps = {
  cancelFunctions: CancelFunctions;
  brandCode: string;
  productCategory: CodeNameModel;
};

export const setProductCategory = createAsyncThunk<void, SetProductCategoryProps, ThunkApiConfig>(
  'creative/setProductCategory',
  async ({ cancelFunctions, brandCode, productCategory }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;

    try {
      dispatch(
        setCreativeProductCategory({
          productCategory,
          brandCode,
        }),
      );

      const { commercialId, advertiser, marketId } = getState().creative;

      const advertiserCode = advertiser ? advertiser.code : null;

      if (commercialId) {
        await updateCreativeCommercial(cancelFunctions, commercialId, advertiserCode, brandCode, productCategory?.code);
      } else {
        const { id } = await createCreativeCommercial(
          cancelFunctions,
          marketId,
          advertiserCode,
          brandCode,
          productCategory?.code,
        );

        dispatch(setCommercialId(id));
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
);
